import { assign, createMachine } from 'xstate';
import { Context, Events } from './types';

export const deletePaymentProfile = createMachine<Context, Events>({
  id: 'deletePaymentProfile',
  predictableActionArguments: true,
  initial: 'idle',
  context: {
    error: null,
  },
  states: {
    idle: {
      on: {
        DELETE_PAYMENT_PROFILE: {
          target: 'loading',
        },
      },
    },
    loading: {
      invoke: {
        src: 'deletePaymentProfile',
        onDone: {
          actions: 'onDeleteProfileSuccess',
          target: 'success',
        },
        onError: {
          target: 'error',
          actions: assign((_ctx, event) => ({
            error: {
              errorCode: event.data?.errorCode,
              subscriptions: event.data?.subscriptions,
            },
          })),
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
